var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "voucherInfo", attrs: { model: _vm.voucher } },
    [
      _vm.dbVoucher.deviceFlag && _vm.dbVoucher.deviceBound
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("换下配件")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "swb-btn-link",
                  on: { click: _vm.selectMountSpecific }
                },
                [_vm._v("选择")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-layout" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.voucher.servcWorkAccItemList1,
                      border: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "accName",
                        label: "配件名称",
                        align: "left",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-success" },
                                [_vm._v("个")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(rows.row.accName))])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "vendorSn",
                        label: "厂商序列号",
                        align: "left",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "center", width: "80", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.removeItem1(scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("换上配件")]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "swb-btn-link", on: { click: _vm.showAccDlg } },
          [_vm._v("选择")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.voucher.servcWorkAccItemList2, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "accName",
                  label: "配件名称",
                  align: "left",
                  width: "150",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        (rows.row.vendorSn != null &&
                          rows.row.vendorSn != "") ||
                        rows.row.specificFlag
                          ? _c(
                              "span",
                              { staticClass: "swb-tags swb-tags-success" },
                              [_vm._v("个")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(rows.row.accName))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "vendorSn",
                  label: "厂商序列号",
                  align: "left",
                  width: "150",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  label: "配件单价",
                  align: "right",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "配件个数", prop: "quantity", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.specificFlag == null ||
                        rows.row.specificFlag == false ||
                        (rows.row.vendorSn != null && rows.row.vendorSn != "")
                          ? _c("div", [
                              rows.row.vendorSn == null ||
                              rows.row.vendorSn == ""
                                ? _c(
                                    "div",
                                    [
                                      rows.row.merchantType == null ||
                                      rows.row.merchantType == 3
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "servcWorkAccItemList2." +
                                                  rows.$index +
                                                  ".quantity",
                                                rules: {
                                                  validator: _vm.checkNumber,
                                                  trigger: "blur"
                                                }
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  type: "number",
                                                  min: 1,
                                                  placeholder: "请输入配件个数"
                                                },
                                                model: {
                                                  value: rows.row.quantity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      rows.row,
                                                      "quantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "rows.row.quantity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v(_vm._s(rows.row.quantity))
                                          ])
                                    ],
                                    1
                                  )
                                : _c("div", [_vm._v("1")])
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unit",
                  label: "单位",
                  align: "right",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "replaceFlag", label: "是否更换", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.vendorSn != null && rows.row.vendorSn != ""
                          ? _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: rows.row.replaceFlag,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "replaceFlag", $$v)
                                  },
                                  expression: "rows.row.replaceFlag"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: {
                                      label: true,
                                      disabled: rows.row.merchantType == 4
                                    }
                                  },
                                  [_vm._v("是")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: {
                                      label: false,
                                      disabled: rows.row.merchantType == 4
                                    }
                                  },
                                  [_vm._v("否")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "replaceDesc", label: "更换说明" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.vendorSn != null &&
                        rows.row.vendorSn != "" &&
                        rows.row.replaceFlag
                          ? _c("el-input", {
                              attrs: { disabled: rows.row.merchantType == 4 },
                              model: {
                                value: rows.row.replaceDesc,
                                callback: function($$v) {
                                  _vm.$set(rows.row, "replaceDesc", $$v)
                                },
                                expression: "rows.row.replaceDesc"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "replaceDesc", label: "更换信息", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.replacedVendorSn != null &&
                        rows.row.replacedVendorSn != ""
                          ? _c("span", [
                              _vm._v(
                                "更换了" + _vm._s(rows.row.replacedVendorSn)
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", width: "200", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.merchantType == null ||
                        rows.row.merchantType == 3
                          ? _c("div", [
                              rows.row.vendorSn != null &&
                              rows.row.vendorSn != "" &&
                              rows.row.replaceFlag &&
                              _vm.voucher.servcWorkAccItemList1.length > 0
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.replaceSpecific(rows.$index)
                                        }
                                      }
                                    },
                                    [_vm._v("匹配换下")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (rows.row.vendorSn != null &&
                                rows.row.vendorSn != "") ||
                              rows.row.specificFlag
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.selectSpecific(rows.$index)
                                        }
                                      }
                                    },
                                    [_vm._v("选择个体配件")]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        (rows.row.vendorSn != null &&
                          rows.row.vendorSn != "") ||
                        rows.row.merchantType == null ||
                        rows.row.merchantType == 3
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeItem2(rows.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("备注")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", {}, [_vm._v("备注")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.voucher.shareAccMemo,
                  callback: function($$v) {
                    _vm.$set(_vm.voucher, "shareAccMemo", $$v)
                  },
                  expression: "voucher.shareAccMemo"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daa0aa3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daa0aa3c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkShareAccAdd.vue
// module id = 2841
// module chunks = 0